import React from 'react';
import PropTypes from 'prop-types'

import { ReactComponent as ErrorSVG } from '../../svg/danger.svg'
import { ReactComponent as SuccessSVG } from '../../svg/check.svg'
import { ReactComponent as CloseSVG } from '../../svg/close.svg'
import IconButton from '../icon_button/IconButton'

import css from './Alert.module.scss'

const Alert = ({text, hidden, dismissHandler, type}) => {
  if (hidden) {
    return (<div/>)
  }

  const alertIcon = type === 'success'
    ? <SuccessSVG className={css.icon}/>
    : <ErrorSVG className={css.icon}/>
  const typeCss = type === 'success' ? css.success : css.error
  
  return (
    <div className={css.alert}>
      <div className={`${css.iconBox} ${typeCss}`}>{alertIcon}</div>
      <div className={`${css.messageBox} ${typeCss}`}>
        <div>{text}</div>
        <div><IconButton clickHandler={dismissHandler}><CloseSVG className={css.icon}/></IconButton></div>
      </div>
    </div>
  )
}

Alert.propTypes = {
  text: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  dismissHandler: PropTypes.func,
  type: PropTypes.oneOf(['success', 'error'])
}

Alert.defaultProps = {
  hidden: true,
  dismissHandler: Function.prototype,
  type: 'success'
}

export default Alert;
